import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../contexts/LanguageContext';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-white pt-20" data-id="element-157">
      {/* Subtle Background Elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-32 bg-gradient-to-b from-transparent to-gold/30" data-id="element-158"></div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-159">
        <div className="max-w-4xl mx-auto text-center" data-id="element-160">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-161">
            <p className="text-xs font-semibold tracking-[0.3em] text-gold uppercase mb-8" data-id="element-162">
              {t('hero.eyebrow')}
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.1,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-163">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-light tracking-tight text-[#0A0A0A] leading-[1.1] mb-8" data-id="element-164">
              {t('hero.headlineMain')}{' '}
              <span className="font-serif italic text-gold pr-2" data-id="element-165">
                {t('hero.headlineAccent')}
              </span>
            </h1>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-166">
            <p className="text-lg md:text-xl text-black/60 font-light max-w-2xl mx-auto leading-relaxed mb-12" data-id="element-167">
              {t('hero.subheadline')}
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3,
          ease: [0.16, 1, 0.3, 1]
        }} className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-168">
            <a href="#contact" className="w-full sm:w-auto px-8 py-4 bg-[#0A0A0A] text-white text-sm tracking-widest uppercase hover:bg-gold transition-colors duration-300" data-id="element-169">
              {t('hero.ctaPrimary')}
            </a>
            <a href="#about" className="w-full sm:w-auto px-8 py-4 border border-gold/50 text-[#0A0A0A] text-sm tracking-widest uppercase hover:border-gold hover:bg-gold/5 transition-colors duration-300" data-id="element-170">
              {t('hero.ctaSecondary')}
            </a>
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 1
    }} className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-4" data-id="element-171">
        <div className="w-px h-16 bg-gradient-to-b from-gold/50 to-transparent" data-id="element-172"></div>
      </motion.div>
    </section>;
}